import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-47a3d281")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ElementOutline = _resolveComponent("ElementOutline")

  return (_openBlock(), _createBlock("div", {
    class: "base-element-text",
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      _createVNode("div", {
        class: "element-content",
        style: {
          backgroundColor: _ctx.elementInfo.fill,
          opacity: _ctx.elementInfo.opacity,
          textShadow: _ctx.shadowStyle,
          lineHeight: _ctx.elementInfo.lineHeight,
          letterSpacing: (_ctx.elementInfo.wordSpace || 0) + 'px',
        }
      }, [
        _createVNode(_component_ElementOutline, {
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height,
          outline: _ctx.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createVNode("div", {
          class: "text ProseMirror-static",
          innerHTML: _ctx.elementInfo.content
        }, null, 8, ["innerHTML"])
      ], 4)
    ], 4)
  ], 4))
})